import classNames from 'classnames';
import React, { useState } from 'react';

import { t } from '@/utility/localization';

import Icon from '@/components/npl/Icon';

const AddContent = ({
  dropzoneProps,
  handleAddLinkSectionClick,
  showSupportText = true
}) => {
  const [showDndSupportText, setShowDndSupportText] =
    useState(showSupportText);
  const [showLinkSupportText, setShowLinkSupportText] =
    useState(showSupportText);

  const { isDragActive, open: openFileInput } = dropzoneProps;

  const onFileDropzoneHover = () => {
    setShowDndSupportText(true);
  };

  const onFileDropzoneHoverExit = () => {
    if (showSupportText) {
      return;
    }
    setShowDndSupportText(false);
  };

  const onLinkZoneHover = () => {
    setShowLinkSupportText(true);
  };

  const onLinkZoneHoverExit = () => {
    if (showSupportText) {
      return;
    }
    setShowLinkSupportText(false);
  };

  // <div className="c-AddContent flex items-center justify-between animate-fadeInLibrary h-[104px] space-x-24">
  return (
    <div className="c-AddContent flex h-[104px] flex-col items-center justify-center space-x-24 md:flex-row md:items-center md:justify-between">
      {/* File Dropzone */}
      {/* <div className={`ease-out duration-300 ${uploadClassNames}`}> */}
      <div
        onMouseEnter={onFileDropzoneHover}
        onMouseLeave={onFileDropzoneHoverExit}
        className={classNames('h-[104px] duration-300 ease-out', {
          // 397px is the width of "OR" and "Add Link" section combined.
          // Width of this section should be 100% minus the rest of the section.
          // Have to use calc for animation and cannot use flex-1
          'w-[328px] md:w-[calc(100%-397px)]': !isDragActive,
          'w-full': isDragActive
        })}>
        <div
          className={`flex h-full w-full flex-shrink-0 flex-col items-center justify-center rounded-12 px-16 py-24 md:p-0 ${
            isDragActive
              ? 'border-4 border-solid border-blurple-70'
              : 'border-1 border-dashed border-neutral-70'
          } hover:bg-npl-neutral-light-solid-2`}
          onClick={openFileInput}
          role="button"
          tabIndex={0}>
          <div className="flex items-center justify-center space-x-8">
            <Icon name="upload-cloud-01" />
            <p className="my-8 text-16 font-semibold text-neutral-10">
              {isDragActive ? (
                t('drop-to-upload-files')
              ) : (
                <span>
                  {t('drag-drop-to')}{' '}
                  <span className="underline">{t('upload-files')}</span>
                </span>
              )}
            </p>
          </div>
          {!isDragActive && showDndSupportText ? (
            <>
              <p className="text-12 text-neutral-50">
                {t('supported-files-jpg-png-mp')}
              </p>
            </>
          ) : null}
        </div>
      </div>

      {/* OR */}
      {!isDragActive && (
        <p className="text-18 font-medium text-neutral-50">{t('or1')}</p>
      )}

      {/* Add Link Section */}
      {!isDragActive && (
        <div
          onMouseEnter={onLinkZoneHover}
          onMouseLeave={onLinkZoneHoverExit}
          className="h-[104px] w-[328px] duration-300 ease-out">
          <div
            className="flex h-full w-full flex-shrink-0 flex-col items-center justify-center rounded-12 border-1 border-dashed border-neutral-70 p-24 hover:bg-npl-neutral-light-solid-2"
            onClick={handleAddLinkSectionClick}
            role="button"
            tabIndex={0}>
            <div className="flex items-center justify-center space-x-8">
              <Icon name="link-01" />
              <p className="text-16 font-semibold text-neutral-10">
                {t('add-link')}
              </p>
            </div>

            {showLinkSupportText && (
              <p className="mt-8 max-w-[240px] text-center text-12 text-neutral-50">
                {t('direct-your-members-to-youtube')}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// export default AddContent;
export default React.memo(AddContent);
